import { render, staticRenderFns } from "./sliderCarousel.vue?vue&type=template&id=4e7a1061&scoped=true"
import script from "./sliderCarousel.vue?vue&type=script&lang=js"
export * from "./sliderCarousel.vue?vue&type=script&lang=js"
import style0 from "./sliderCarousel.vue?vue&type=style&index=0&id=4e7a1061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a1061",
  null
  
)

export default component.exports